import CreditScore from "../../../jsx/components/Dashboard/CreditScore/creditscore";

const CreditScoreWrapper = () => {
  return <CreditScore />;
};

export default constore(CreditScoreWrapper);
